module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Re-establish Session</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$dismiss()\">Close</span>\n        </div>\n    </div>\n</div>\n<form class=\"modal-body\" role=\"form\" novalidate name=\"signinForm\" ng-submit=\"signin.submit(true)\">\n    <div status-row></div>\n    <ng-include src=\"'/signin/signin.fields.html'\"></ng-include>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./project/modals/signin/signin.html
// module id = 857
// module chunks = 3